module.exports = __webpack_public_path__ + "img/lead-101z.08449466.png";